import { call, put, delay, takeLatest, select } from "redux-saga/effects";
import PrestadorActions, {
  Types as PrestadorTypes,
} from "../../stores/prestador/Actions";
import PrestadorService from "../../services/prestador/PrestadorService";
import ResponseCode from "../../services/ResponseCode";
import { TOKEN_TYPE } from "../../utils/Constant";

function* getProcedimientosPss(request) {
  yield put(PrestadorActions.getProcedimientosPssLoading());

  if(request.payload?.applyFilter){
    yield delay(500)
  }

  const procedimientosResponse = yield call(
    PrestadorService.consultarProcedimientosPss,
    request.payload
  );

  if (
    !procedimientosResponse?.respuesta ||
    procedimientosResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrestadorActions.getProcedimientosPssFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (procedimientosResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      PrestadorActions.getProcedimientosPssFailure(
        procedimientosResponse?.respuesta
      )
    );
    return;
  }

  const { procedimientos } = procedimientosResponse?.data;

  const coberturas = procedimientos
    ?.map((procedimiento) => {
      return {
        ...procedimiento,
        nombreCobertura : procedimiento.nombreCobertura
      };
    })
    ?.sort((a, b) => a.cobertura - b.cobertura);

  yield put(
    PrestadorActions.getProcedimientosPssSuccess({
      coberturas,
      paginacion: procedimientosResponse?.paginacion,
    })
  );
}

function* getMedicos(request) {
  yield put(PrestadorActions.getMedicosLoading());

  yield delay(500)

  const medicosResponse = yield call(
    PrestadorService.getMedicos,
    request.payload
  );

  const medicos = medicosResponse?.map((medico) => {
    return {
      key: medico.codigoMedico + medico.nombreMedico,
      codigo: medico.codigoMedico ? String(medico.codigoMedico) : "0",
      descripcion: medico.nombreMedico,
      codigoEspecialidad: medico.codigoEspecialidad,
      descripcionEspecialidad: medico.descripcionEspecialidad,
    };
  });

  yield put(PrestadorActions.getMedicosSuccess({ medicos }));
}

function* consultarTipoPssNoMedico(request) {
  yield put(PrestadorActions.consultarTipoPssNoMedicoLoading());

  let accessToken = request.payload?.accessToken;
  
  if (!accessToken) {
    const authState = yield select((state) => state.auth);
    accessToken = authState?.authUserData?.accessToken;
  }
  
  if (!accessToken) {
    yield put(
      PrestadorActions.consultarTipoPssNoMedicoFailure({
        codigo: ResponseCode.UNAUTHORIZED.code,
        mensaje: "Token de acceso no disponible",
      })
    );
    return;
  }

  const requestWithHeaders = {
    requestData: { codigoPss: request.payload.codigoPss },
    requestHeaders: {
      Authorization: `${TOKEN_TYPE.BEARER} ${accessToken}`,
    },
  };

  const tipoPssNoMedicoResponse = yield call(
    PrestadorService.consultarTipoPssNoMedico,
    requestWithHeaders
  );

  if (
    !tipoPssNoMedicoResponse?.respuesta ||
    tipoPssNoMedicoResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      PrestadorActions.consultarTipoPssNoMedicoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  // Evaluar solo si el mensaje es "OK"
  const mensajeRespuesta = tipoPssNoMedicoResponse?.respuesta?.mensaje;
  const esExitoso = mensajeRespuesta === "OK";

  if (!esExitoso) {
    yield put(
      PrestadorActions.consultarTipoPssNoMedicoFailure(
        tipoPssNoMedicoResponse?.respuesta
      )
    );
    return;
  }

  yield put(
    PrestadorActions.consultarTipoPssNoMedicoSuccess(
      tipoPssNoMedicoResponse?.data || tipoPssNoMedicoResponse
    )
  );
}

const exportedArray = [
  takeLatest(PrestadorTypes.GET_PROCEDIMIENTOS_PSS, getProcedimientosPss),
  takeLatest(PrestadorTypes.GET_MEDICOS, getMedicos),
  takeLatest(PrestadorTypes.CONSULTAR_TIPO_PSS_NO_MEDICO, consultarTipoPssNoMedico),
];

export default exportedArray;
